import { mutate } from 'swr';

import {
  SWR_KEY_CUSTOM_DATA_ATTRIBUTES,
  getCustomEmployeeFieldAttributes,
} from '~/data/customData/useCustomDataAttributes';
import {
  SWR_KEY_CUSTOM_EMPLOYEE_DATA,
  getCustomEmployeeFields,
} from '~/data/customData/useCustomEmployeeData';

export const prefetchCustomData = (empId: string) => {
  mutate([SWR_KEY_CUSTOM_EMPLOYEE_DATA, empId], getCustomEmployeeFields(empId));
  mutate(SWR_KEY_CUSTOM_DATA_ATTRIBUTES, getCustomEmployeeFieldAttributes());
};
